import { render } from "./ObesityClinic.vue?vue&type=template&id=20b48c64"
import script from "./ObesityClinic.vue?vue&type=script&lang=js"
export * from "./ObesityClinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__